<template>
  <div class="container">
    <div v-if="flag" style="position: fixed; bottom: 0; left: 3px; cursor: pointer; z-index: 999;"><img src="../assets/home/closeImg.jpg" style="width: 50px; height: 50px;" @click="closeWelcome" /></div>
    <div class="center">
      <div class="wordList">
        <div class="wordItem">
          <div class="showWord">信用财富，提升金融能级</div>
          <h2 class="b">服务实体 / 防范风险 / 便利快捷</h2>
        </div>
        <div class="wordItem">
          <div class="showWord">信息共享，赋能普惠金融</div>
          <h2 class="b">普惠 / 便捷 / 数字 / 智能</h2>
        </div>
        <div class="wordItem">
          <div class="showWord">一键授信，构建银企桥梁</div>
          <h2 class="b">零接触、秒响应、一键申请、秒批秒贷</h2>
        </div>
      </div>
      <div
        class="button"
        @click="goIndex"
      >点击进入</div>
    </div>
    <!-- 你可以添加个多“.slideshow-image”项目, 记得修改CSS -->
    <div class="slideshow" >
      <img
        class="slideshow-image"
        src='../assets/imgs/welcome/banner1.png'
      />
      <img
        class="slideshow-image"
        src='../assets/imgs/welcome/banner5.png'
      />
      <img
        class="slideshow-image"
        src='../assets/imgs/welcome/banner3.png'
      />
      <img
        class="slideshow-image"
        src='../assets/imgs/welcome/banner1.png'
      />
    </div>
  </div>
</template>
<script>
import { showFlag } from '@/api/welcome'
export default {
  data () {
    return {
      activate: 0,
      flag: false,
    }
  },
  mounted () {
    showFlag().then(res => {
      console.log(res)
      if (res.data.data.type == 1) {
        this.flag = true;
      }else{
        this.flag = false;
      }
    })
  },
  methods: {
    goIndex () {
      this.$router.push({
        path: "index",
      })
    },
    closeWelcome () {
      window.close();
    },
  }
}
</script>
<style lang='less' scoped>
// .container{
//     filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
//   -webkit-filter: grayscale(100%);
// }
.center {
  position: fixed;
  left: 900px;
  top: 450px;
  transform: translate3d(-50%, -50%, 0);
  z-index: 99;
  text-align: center;
  font-family: Raleway, sans-serif;
  font-weight: 300;
  text-transform: uppercase;
  line-height: 1.5;
  color: white;
  user-select: none;
  width: 682px;
  @keyframes widths {
    0% {
      width: 0;
    }
    25%,
    100% {
      width: 100%;
    }
  }
  .wordList {
    position: relative;
    height: 201px;
    .wordItem {
      //animation: fade 6s infinite;
      position: absolute;
      .showWord {
        font-size: 62px;
        font-family: Alibaba PuHuiTi;
        color: #ffffff;
        line-height: 95px;
        font-weight: normal;
        margin-top: 0;
        text-align: center; /* 文字横向居中 */
        white-space: nowrap; /* 文字不换行 */
        overflow: hidden; /* 多余的文字内容隐藏 */
        //animation: widths 6s steps(11) infinite; /* 重点 steps() */
      }
      .b {
        margin-top: 40px;
        margin-bottom: 30px;
        font-size: 24px;
        font-family: MicrosoftYaHei;
        color: #fff;
        z-index: 9;
      }
    }
  }
  .button {
    width: 355px;
    height: 70px;
    border-radius: 10px;
    font-size: 20px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #000000;
    line-height: 70px;
    text-align: center;
    background: #e6e6e6;
    opacity: 0;
    cursor: pointer;
    z-index: 9;
    margin: 0 auto;
    &:hover {
      opacity: 0.8;
    }
  }
}

* {
  margin: 0;
  padding: 0;
}

.slideshow {
  position: absolute;
  // width: 100vw;
  width: 1920px;
  height: calc(100vh - 30px);
  overflow: hidden;
  // min-width: 1320px;
 // height: 907px;
}

.slideshow-image {
  position: absolute;
  width: 100%;
  height: 100%;
  background: no-repeat 50% 50%;
  background-size: cover;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-duration: 18s;
  opacity: 1;
  transform: scale(1.2);
}
.slideshow-image:nth-child(4) {
  animation-name: kenburns-1;
  //z-index: 4;
}
.slideshow-image:nth-child(3) {
  animation-name: kenburns-2;
  //z-index: 3;
}
.slideshow-image:nth-child(2) {
  animation-name: kenburns-3;
  //z-index: 2;
}
.slideshow-image:nth-child(1) {
  animation-name: kenburns-4;
}
.wordItem:nth-child(1) {
  opacity: 0;
  animation: fade-1 18s linear infinite;
  z-index: 4;
}
.wordItem:nth-child(2) {
  opacity: 0;
  animation: fade-2 18s linear infinite;
  z-index: 3;
}
.wordItem:nth-child(3) {
  opacity: 0;
  animation: fade-3 18s linear infinite;
  z-index: 2;
}

@keyframes kenburns-1 {
  0% {
    opacity: 1;
    transform: scale(1.2);
  }
  29% {
    opacity: 1;
  }
  33% {
    opacity: 0;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(1.2);
  }
  //0% {
  //  opacity: 1;
  //  transform: scale(1.2);
  //}
  //29% {
  //  opacity: 1;
  //}
  //33% {
  //  opacity: 0;
  //  transform: scale(1);
  //}
  //95% {
  //  opacity: 0;
  //  transform: scale(1.2);
  //}
  //96% {
  //  opacity: 1;
  //  transform: scale(1.21);
  //}
  //100% {
  //  opacity: 1;
  //  transform: scale(1.2);
  //}
}

@keyframes kenburns-2 {
  0%,
  25% {
    opacity: 1;
    transform: scale(1.2);
  }
  63% {
    opacity: 1;
  }
  67% {
    opacity: 0;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(1.2);
  }
  //29% {
  //  opacity: 1;
  //  transform: scale(1.2);
  //}
  //63% {
  //  opacity: 1;
  //}
  //67% {
  //  opacity: 0;
  //  transform: scale(1);
  //}
}

@keyframes kenburns-3 {
  0%,
  59% {
    opacity: 1;
    transform: scale(1.2);
  }
  96% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
  //63% {
  //  opacity: 1;
  //  transform: scale(1.2);
  //}
  //96% {
  //  opacity: 1;
  //}
  //100% {
  //  opacity: 0;
  //  transform: scale(1);
  //}
}

@keyframes kenburns-4 {
  0%,
  92% {
    opacity: 1;
    transform: scale(1.24);
  }
  100% {
    opacity: 1;
    transform: scale(1.2);
  }
}

@keyframes fade-1 {
  0% {
    opacity: 0;
    filter: blur(10px);
  }
  2% {
    opacity: 1;
    filter: blur(0px);
  }
  31% {
    opacity: 1;
    filter: blur(0px);
  }
  33% {
    opacity: 0;
    filter: blur(10px);
  }
}

@keyframes fade-2 {
  33% {
    opacity: 0;
    filter: blur(10px);
  }
  35% {
    opacity: 1;
    filter: blur(0px);
  }
  65% {
    opacity: 1;
    filter: blur(0px);
  }
  67% {
    opacity: 0;
    filter: blur(10px);
  }
}

@keyframes fade-3 {
  67% {
    opacity: 0;
    filter: blur(10px);
  }
  69% {
    opacity: 1;
    filter: blur(0px);
  }
  98% {
    opacity: 1;
    filter: blur(0px);
  }
  100% {
    opacity: 0;
    filter: blur(10px);
  }
}
</style> 